const clone_template = `
<div class="modal-dialog modal-lg" id="dialog-devicegroup-settings">
    <div class="modal-content">
        <div class="modal-header">
            <div class="info">Clone Development Device Group : {{name}}</div>
            <button type="button" class="btn-close" data-dismiss="modal">X</button>
        </div>
        <div class="modal-alert-container">
            <div class="alert"></div>
        </div>
        <form>
            <div class="modal-body">
                <div class="form-group devicegroup-name-section col-xs-6">
                    <label for="name">Device Group Name</label>
                    <input type="text" maxlength="100" name="name" placeholder="Enter a name..." value="{{name}}" class="form-control create-name" />
                    <span class="help-block name-counter">0 / 100</span>
                    <label for="description">Device Group Description</label>
                    <textarea class="form-control description" name="description" maxlength="300" placeholder="Enter description here">{{description}}</textarea>
                    <span class="help-block description-counter">0 / 300</span>
                    <div class="account-region"></div>
                    <div class="product-region"></div>
                </div>
                <div class="form-group devicegroup-name-section col-xs-6">
                    {{#if devicegroup_profiles}}
                        <label for="profile">Profile <span class="glyphicon glyphicon-question-sign"
                            aria-hidden="true" data-toggle="tooltip" data-placement="bottom"
                            title="A device group's profile can be used to run it's devices on special development servers. 
                            Setting it to Default will make it's devices run on the usual software. 
                            Not all device group profiles may be available in all Regions." />
                        </label>
                        <select name="profile" class="form-control devicegroup-profile">
                            {{#each devicegroup_profiles}}
                            <option value="{{this.id}}" {{#if this.selected}}selected{{/if}}>{{this.attributes.name}}</option>
                            {{/each}}
                        </select>
                    {{/if}}
                    <div class="environment-variables">
                        <label for="env_vars">Environment Variables</label>
                        {{#if edit_env_vars}}
                            <textarea rows="6" class="form-control env_vars" name="env_vars" maxlength="300" 
                                placeholder="Write Environment Variables here as valid JSON">{{env_vars}}</textarea>
                            <span class="help-block">Custom variables that can be used in the Device Group's code. Only Owners have permissions to edit. 
                            Must be valid JSON.  Keys must be alphanumeric, and start with a letter. Values must be strings or numbers.  A new deployment
                            will need to be created, and devices restarted.</span>
                            <pre class="help-block code">e.g. {"foo":"bar"}</pre>
                        {{else}}
                            {{#if show_env_vars_keys}}
                                <pre class="code">{{env_vars_keys}}</pre>
                                <span class="help-block">Custom Variables to use in this Device Group's code. Only Owners have permissions to edit. 
                                Values may be strings, booleans, or numbers.</span>
                            {{/if}}
                        {{/if}}
                     </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-link " data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary submit">Submit</button>
                <div class="loader">Loading...</div>
            </div>
        </form>
    </div>
</div>`;

import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import ProductSelector from '@/views/modules/product_selector';
import AccountSelector from '@/views/modules/account_selector';

var MAX_DESCRIPTION_LENGTH = 300;
var MAX_NAME_LENGTH = 100;

var globalCh = Radio.channel('global');
var apiCh = Radio.channel('api');

function perm_check(active, primary, type){
    if ( type === 'development_devicegroup' && active.permits(primary, 'update_development_vars') ) {
        return true;
    }
    return false;
}

var CloneDeviceGroupDialog = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(clone_template),
    ui: {
        name: '.create-name',
        description: '.form-control.description',
        devicegroup_profile: '.devicegroup-profile',
        product: '.product',
        submit_btn: '.submit',
        load_spinner: '.loader',
        description_length_counter: '.description-counter',
        name_length_counter: '.name-counter',
        cancel: '.cancel',
        tooltips: '[data-toggle="tooltip"]',
        env_vars: '.environment-variables',
        env_vars_textarea: '.environment-variables textarea',
        region_dropdown: '.region-dropdown',
        region_label: '.region-label',
    },
    regions: {
        deployment_settings: '.deployment-settings',
        product_region: '.product-region',  
        production_pagination_controls: '.production-pagination',
        account_region: '.account-region',
        region_menu: '@ui.region_dropdown',
    },
    events: {
        'submit form': 'handle_submit',
        'keyup @ui.description': 'validate_description',
        'paste @ui.description': 'validate_description',
        'change @ui.description': 'validate_description',
        'mouseup @ui.description': 'validate_description',
        'keyup @ui.name': 'validate_name',
        'paste @ui.name': 'validate_name',
        'change @ui.name': 'validate_name',
        'mouseup @ui.name': 'validate_name',
    },
    childViewEvents: {
        'change:account' : 'change_account',
        'change:product' : 'change_product'
    },
    initialize: function (options) {
        this.owner = this.model.rel.get('owner');
        this.product = this.model.rel.get('product');
        this.deployment = this.model.rel.get('current_deployment');
        if (this.deployment) this.deployment.fetch();
        this.destroyOnClose();
        this.focusFirstInput();
    },
    templateContext: function () {
        let self = this;
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');
        let devicegroup_profiles = JSON.stringify(this.owner.devicegroup_profiles);
        let devicegroups = apiCh.request('development_devicegroup');
        let current_devicegroup_profile = undefined;
        if ( devicegroup_profiles ) devicegroup_profiles = JSON.parse(devicegroup_profiles);
        if ( this.model.type === 'development_devicegroup' && this.model.rel.get('profile') && devicegroup_profiles ) {
            current_devicegroup_profile = devicegroups.find(
                function(p){
                    return p.id ===  self.model.rel.get('profile').id;
                }
            );
            current_devicegroup_profile.selected = true;
        }

        let env_vars = null;
        let env_vars_keys = null;
        let edit_env_vars = false;
        let show_env_vars_keys = false;
        
        if ( this.model && this.model.get('env_vars') ) { 
            env_vars = JSON.stringify(this.model.get('env_vars'), null, 4);
        }
        if ( perm_check( active, primary, 'development_devicegroup') ) {
            edit_env_vars = true;
        } else {
            show_env_vars_keys = true;
            if ( this.model && this.model.get('env_vars') ) {
                env_vars_keys = Object.keys(this.model.get('env_vars'));
            }
        }
        if ( !env_vars_keys ) env_vars_keys = "no variables";
        return {
            dialog_title: this.getOption('dialog_title'),
            name: this.model.get('name'),
            product: this.product.get('name'),
            owner: this.owner.get('name'),
            devicegroup_profiles: devicegroup_profiles,
            show_env_vars_keys: show_env_vars_keys,
            edit_env_vars: edit_env_vars,
            env_vars: env_vars,
            env_vars_keys: env_vars_keys,
        };
    },
    onRender: function () {
        var primary = globalCh.request('primary_account');
        this.ui.tooltips.tooltip();
        this.ui.name.val(this.model.get('name'));
        this.ui.description.val(this.model.get('description'));
        this.validate();
        this.showChildView('account_region', new AccountSelector({ model: this.model }));
        this.render_products(primary.id); 
    },
    change_product: function(val) {
        this.product = apiCh.request('product', { id: val });
    },
    change_account: function(val) {
        this.render_products(val);
        this.owner = apiCh.request('account', { id: val });
    },
    render_products: function(val) {
        let products = apiCh.request('product');
        products.fetch({
            data: {
            'filter[owner.id]': val,
            'page[size]': 100
            },
        }).then((resp)=>{
            this.showChildView('product_region', new ProductSelector({ model: this.model, products: resp.data }));
        });
    },
    handle_submit: function(e){
        let active = globalCh.request('active_account');
        let primary = globalCh.request('primary_account');

        if ( e ) {
            e.preventDefault();
        }
        let devicegroup_profile = this.ui.devicegroup_profile.val();
        let profile = null;
        this.ui.load_spinner.show();
        if ( this.owner.devicegroup_profiles == undefined || devicegroup_profile == '' ) {
            profile = null;
        } else {
            profile = this.owner.devicegroup_profiles.find(
                function(p){
                    return p.id === devicegroup_profile;
                }
            );
            profile = {
                id: profile.id,
                type: profile.type
            };
        }
        let env_vars_string = this.ui.env_vars_textarea.val();
        let env_vars = null;
        try {
            env_vars = JSON.parse(env_vars_string);
        } catch ( e ) {
            if (  env_vars_string && env_vars_string.length > 0 ) {
                let error = {
                    responseJSON : {
                        errors: [
                            { detail: e }
                        ]
                    }
                };
                this.handle_error(error);
                return;
            }
        }
        let opts = {
            name: this.ui.name.val(),
            description: this.ui.description.val(),
            type: this.model.type 
        };

        if ( perm_check(active, primary, opts.type) ) {
                opts.env_vars = env_vars;
        }

        let devicegroups = apiCh.request(this.model.type);
        devicegroups.create(
            opts,
            {
                creator: primary.id,
                owner: this.owner.id,
                profile: profile,
                product: this.product,
                wait: true,
                success: function(model){ this.on_success(model); }.bind(this),
                error: function (model, response) { this.handle_error(response); }.bind(this)
            }
        );
    },
    deploy_to_new_devicegroup: function() {
        let deployments = apiCh.request('deployment');

        var headers = {};
//        var totp = this.ui.totp_input.val();
//        if ( this.mfa_required() ) {
//            headers = {
//                'x-electricimp-otp-token': totp
//            };
//        }
        if ( !this.deployment || !this.deployment.type ) return;
        var options = {
            type: this.deployment.type,
            attributes: {
                description: this.deployment.get('description'),
                agent_code: this.deployment.get('agent_code'),
                device_code: this.deployment.get('device_code')
            },
            relationships: {
                devicegroup: this.new_devicegroup.toReference(),
            }
        };
        deployments.create(
            options,
            {
                merge: true,
                // Without wait: true, ID is undefined 
                wait: true,
                headers: headers,
                success: function(deployment, response){
                    this.handle_success();
                }.bind(this),
                error: function(model, resp) {
                    this.handle_error(resp);
                }.bind(this)
            }
        );
    },
    on_success: function (devicegroup) {
        Radio.request('alerts', 'showAlert', {
            message: 'Successfully created new Device Group: "' +
            devicegroup.get('name') + '"',
            messageType: 'success'
        });
        this.new_devicegroup = devicegroup;
        if (!this.deployment) {
            this.closeDialog();
            globalCh.request('showCodeEditor', devicegroup.draft, devicegroup);
        }
        this.deploy_to_new_devicegroup(devicegroup);
    },
    handle_success: function(){
        this.ui.load_spinner.hide();
        this.closeDialog();
        globalCh.request(
            'layout_alert', 
            'Successfully updated ' + this.model.get('name') + '.', 'success', 4000);
    },
    handle_error: function(err){
        var error_message;
        if (err) {
            if (err.responseJSON && err.responseJSON.errors) {
                error_message = err.responseJSON.errors[0].detail.message;
            }
        } 
        if (!error_message) {
            error_message = 'Failed to update ' + this.model.get('name');
        }
        this.showAlert('failure', 'Failed to update, ' + error_message);
        this.ui.load_spinner.hide();
        this.listenToOnce(this, 'input', function(){
            this.hideAlert();
        }.bind(this));
    },
    validate_description: function () {
        this.trigger('input');
        this.check_validation(
            this.ui.description,
            MAX_DESCRIPTION_LENGTH,
            this.ui.description_length_counter
        );
    },
    validate_name: function () {
        this.trigger('input');
        this.check_validation(
            this.ui.name,
            MAX_NAME_LENGTH,
            this.ui.name_length_counter
        );
        if (this.ui.name.val()) {
            this.ui.submit_btn.prop('disabled', false);
        } else {
            this.ui.submit_btn.prop('disabled', true);
        }
    },
    validate: function() {
        this.validate_name();
        this.validate_description();
    }
});
export default CloneDeviceGroupDialog;
